module.exports = __webpack_public_path__ + "static/img/01.30487db.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/daytours/tour6/01.jpg
// module id = FPpp
// module chunks = 0